import Button from 'components/Button'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import React, { useState } from 'react'
import JobTypeFilter from './Partials/JobTypeFilter'
import DriveRoleFilter from './Partials/RolesFilter'
import { FilterText, MenuFlex, StyledTab, SubmitFlex } from './Styles/style'

const { TabPane } = StyledTab

const RolesFilter = ({
  jobsList,
  searchValue,
  setSearchValue,
  filterData,
  setFilterData,
  jobTypeLevel,
  setJobTypeLevel,
  jobType,
  setJobType,
  postedDate,
  setPostedDate,
  filterStatus,
  setFilterStatus,
  setPageNum,
  roleFilter,
  setRoleFilter,
  setRoundFilter,
  roundFilter,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const submitFilter = () => {
    setFilterData({
      roleId: roleFilter,
      round: roundFilter,
    })
    setPageNum(0)
    setIsMenuOpen(false)
  }

  const onCancelFilter = open => {
    setIsMenuOpen(!isMenuOpen)
    if (!open) {
      setRoleFilter(filterData?.roleId)
      setRoundFilter(filterData?.round)
    }
  }

  const menu = (
    <MenuFlex column className="filter">
      <FilterText>FILTER BY</FilterText>
      <StyledTab
        border={true}
        tabPosition={'left'}
        type="card"
        padding="15px"
        popupClassName="filter"
        textColor={'#3249D7'}
      >
        <TabPane tab="Roles" key="1">
          <JobTypeFilter
            roleFilter={roleFilter}
            setRoleFilter={setRoleFilter}
          />
        </TabPane>
        <TabPane tab="Evaluation Process" key="2">
          <DriveRoleFilter
            setRoundFilter={setRoundFilter}
            roundFilter={roundFilter}
          />
        </TabPane>
      </StyledTab>
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => onCancelFilter(false)} />
        <Button.Primary onClick={submitFilter} text="Apply Filter" />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <TableSearchFilter
      backgroundColor={true}
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      totalCount={jobsList?.count}
      currentCount={
        jobsList?.count < 10
          ? jobsList?.count
          : jobsList?.panelDetails?.length + jobsList?.page * 10
      }
      onOpenChange={onCancelFilter}
    />
  )
}

export default RolesFilter
